"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreementBlockContainer = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles = __importStar(require("./AgreementBlockContainer.css"));
var AgreementBlockContainer = function (_a) {
    var block = _a.block, children = _a.children;
    return (react_1.default.createElement("div", { className: "top-level-block-wrapper", "data-id": block._id, "data-block-type": block.type },
        react_1.default.createElement("section", { className: (0, classnames_1.default)("project-block ".concat(block.type, " qwilr-standard ").concat(block.cssBlockName, " project-block--id-").concat(block._id), styles.fontOverride, styles.blockContainer) },
            react_1.default.createElement("div", { className: "row block-spacer" },
                react_1.default.createElement("div", { className: "large-8 columns large-centered" }, children)))));
};
exports.AgreementBlockContainer = AgreementBlockContainer;
